<template lang="pug">
  component(
    is="div"
    :class="genetatedClass"
  )
    slot
</template>
<script>
import bemMixin from './bem-mixin'

export default {
  name: 'bem-icon',
  mixins: [
    bemMixin,
  ],
  props: {
    block: {
      default: () => 'ls-icon',
    },
  },
}
</script>
